export const API_DEFAULTS = {
    HISTORY_LIMIT: 40,
    HISTORY_OFFSET: 0,
    LIBRARY_PREVIEW_LIMIT: 100,
    LIBRARY_PREVIEW_OFFSET: 0
};

export function applyApiDefaults(policyDefaults = {}) {
    if (!policyDefaults || typeof policyDefaults !== 'object') return;
    Object.entries(policyDefaults).forEach(([key, value]) => {
        if (value == null) return;
        if (key in API_DEFAULTS) {
            API_DEFAULTS[key] = value;
        }
    });
}
